import './style.scss'
import { useContext, useEffect, useState } from "react"
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import { AppSpan, AppText, Circle, CustomContainer, FlexRow, FormGroup } from "src/style"
import ProfilePics from 'src/assets/svg/profile-pics.svg'

export const Profile: React.FC<any> = () => {
    const {info: {userData}} = useContext(AppInfoContext)
    const [input, setInput] = useState({
        firstName: "", lastName: "", 
        email: '', phoneNumber: ''
    })

    useEffect(() => {
        if (userData.id) {
            const {firstName, lastName, email, phoneNumber} = userData
            setInput({...input, firstName, lastName, email, phoneNumber})
        }
    }, [userData])
    
    return (
        <CustomContainer 
            topMargin="5"
        >
            <CustomContainer
                bottomPadding="2.5"
                style={{borderBottom: '1px solid #EDF1F4'}}
            >
                <AppSpan 
                    textSize="1.6" color="#181D27" fontWeight="700"
                >
                    My Profile
                </AppSpan>
            </CustomContainer>
            <FlexRow 
                topMargin="3" wrap="wrap" alignItems="flex-start"
                gap="4" bottomPadding="3.5"
                style={{borderBottom: '1px solid #EDF1F4'}}
            >
                <CustomContainer width="29">
                    <AppSpan 
                        textSize="1.6" fontWeight="700" 
                        color="#1D1D1D"
                    >
                        Profile picture
                    </AppSpan>
                    <AppText 
                        textSize="1.6" color="#4F4F4F"
                    >
                        Orci, porttitor feugiat sociis qui.
                    </AppText>
                </CustomContainer>
                <Circle size="8.4">
                    <img src={ProfilePics} className='img-child'/>
                </Circle>
            </FlexRow>

            <FlexRow 
                topMargin="3"
                alignItems="flex-start" 
                justifyContent="space-between"
                gap="3" bottomPadding="3.5"
                className="settings-row-container"
                style={{borderBottom: '1px solid #EDF1F4'}}
            >
                <CustomContainer width="30" sizeUnit="%">
                    <AppSpan 
                        textSize="1.6" fontWeight="700" 
                        color="#1D1D1D"
                    >
                        Name
                    </AppSpan>
                    <AppText 
                        textSize="1.6" color="#4F4F4F"
                    >
                        Orci, porttitor feugiat sociis qui.
                    </AppText>
                </CustomContainer>
                <FlexRow 
                    justifyContent='space-between' gap='2'
                    width="68" sizeUnit="%"
                    className='setting-row-input'
                >
                    <FormGroup bottomMargin='0'>
                        <label>First Name</label>
                        <input 
                            value={input.firstName}
                            disabled
                        />
                    </FormGroup>
                    <FormGroup bottomMargin='0'>
                        <label>Last Name</label>
                        <input 
                            value={input.lastName}
                            disabled
                        />
                    </FormGroup>
                </FlexRow>
            </FlexRow>
            <FlexRow 
                topMargin="3"
                alignItems="flex-start" 
                justifyContent="space-between"
                gap="3" bottomPadding="3.5"
                className="settings-row-container"
            >
                <CustomContainer width="30" sizeUnit="%">
                    <AppSpan 
                        textSize="1.6" fontWeight="700" 
                        color="#1D1D1D"
                    >
                        Email & Phone Number
                    </AppSpan>
                    <AppText 
                        textSize="1.6" color="#4F4F4F"
                    >
                        Orci, porttitor feugiat sociis qui.
                    </AppText>
                </CustomContainer>
                <FlexRow 
                    justifyContent='space-between' gap='2'
                    width="68" sizeUnit="%"
                    className='setting-row-input'
                >
                    <FormGroup bottomMargin='0'>
                        <label>Email</label>
                        <input 
                            value={input.email}
                            disabled
                        />
                    </FormGroup>
                    <FormGroup bottomMargin='0'>
                        <label>Phone Number</label>
                        <input 
                            value={input.phoneNumber}
                            disabled
                        />
                    </FormGroup>
                </FlexRow>
            </FlexRow>
        </CustomContainer>
    )
}